<form [formGroup]="form" autocomplete="off" class="form-horizontal">

    <div class="mb-3x">
        <div class="form-check">
            <input
                    type="checkbox"
                    class="form-check-input"
                    id="hatNotarAngaben"
                    formControlName="hatNotarAngaben"
                    (ngModelChange)="clearNotar($event)">
            <label class="form-check-label"
                   for="hatNotarAngaben">{{ 'COMMON_UI.FRAGEBOGEN.NOTARANGABEN.TITEL' | translate }}
            </label>
        </div>
    </div>

    <div *ngIf="data.hatNotarAngaben">
        <div class="mb-5x">
            <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.NOTARANGABEN.TITEL' | translate }}</h2>
            <common-ui-personenstamm-daten [(data)]="data.notarPerson"
                                           [readonly]="readonly"></common-ui-personenstamm-daten>
        </div>

        <div class="mb-5x">
            <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ADRESSE.ADRESSE_TITEL' | translate }}</h2>
            <common-ui-adresserfassung [(auslandsadresse)]="data.notarAuslandsadresse"
                                       [(inlandsadresse)]="data.notarInlandsadresse"
                                       [(postfachadresse)]="data.notarPostfachadresse"
                                       [readonly]="readonly"></common-ui-adresserfassung>
        </div>
    </div>

</form>
